import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { 
  FaHome, 
  FaServer, 
  FaGlobe, 
  FaTools, 
  FaBuilding, 
  FaFileContract,
  FaCpanel,
  FaCloud,
  FaDesktop,
  FaSearch,
  FaNetworkWired,
  FaDatabase,
  FaInfoCircle,
  FaPhone,
  FaHandshake,
  FaShieldAlt,
  FaFileAlt,
  FaUndo,
  FaCheck,
  FaInfinity
} from 'react-icons/fa';

const Sitemap = () => {
  const sitemapData = {
    'Main Pages': {
      icon: <FaHome />,
      color: '#21a2a0',
      pages: [
        { name: 'Home', url: '/', description: 'Welcome to ClubHosty - Best Affordable Web Hosting Provider in India' },
        // { name: 'Home (Alt)', url: '/home', description: 'Alternative home page URL' }
      ]
    },
    'Hosting Services': {
      icon: <FaServer />,
      color: '#28a745',
      pages: [
        { name: 'Shared Hosting', url: '/sharedHosting', description: 'Affordable shared web hosting plans perfect for beginners' },
        { name: 'cPanel Hosting', url: '/affordable-cpanel-hosting', description: 'Feature-rich cPanel hosting with easy management' },
        { name: 'Reseller Hosting', url: '/affordable-reseller-web-hosting', description: 'Start your hosting business with our reseller plans' },
        { name: 'VPS Hosting', url: '/affordable-linux-vps-hosting', description: 'Powerful Linux VPS hosting for growing websites' },
        { name: 'Cloud Hosting', url: '/cloud-based-hosting-services', description: 'Scalable cloud hosting solutions for modern businesses' }
      ]
    },
    'Domain Services': {
      icon: <FaGlobe />,
      color: '#007bff',
      pages: [
        { name: 'Domain Registration', url: '/domain', description: 'Register your perfect domain name at best prices' }
      ]
    },
    'Tools & Utilities': {
      icon: <FaTools />,
      color: '#ffc107',
      pages: [
        { name: 'IP Address Lookup', url: '/ip-address', description: 'Find and lookup IP address information' },
        { name: 'DNS Records Checker', url: '/dns-records', description: 'Check DNS records for any domain' },
        { name: 'WHOIS Lookup', url: '/whois', description: 'Get detailed WHOIS information for domains' },
        { name: 'Nameserver Checker', url: '/nameserver', description: 'Check nameserver information for domains' }
      ]
    },
    'Company Information': {
      icon: <FaBuilding />,
      color: '#6f42c1',
      pages: [
        { name: 'About Us', url: '/about', description: 'Learn about ClubHosty - Our journey, values, and commitment' },
        { name: 'Contact Us', url: '/contact', description: 'Get in touch with our 24/7 support team' },
        { name: 'Affiliate Program', url: '/affiliate', description: 'Join our affiliate program and earn commissions' }
      ]
    },
    'Legal & Policies': {
      icon: <FaFileContract />,
      color: '#6c757d',
      pages: [
        { name: 'Privacy Policy', url: '/privacypolicy', description: 'How we protect and handle your personal information' },
        { name: 'Terms & Conditions', url: '/terms-and-conditions', description: 'Terms of service and user agreement' },
        { name: 'Fair Usage Policy', url: '/fair-usage-policy', description: 'Guidelines for fair and responsible usage' },
        { name: 'Refund Policy', url: '/refund-policy', description: 'Our money-back guarantee and refund terms' },
        { name: 'Acceptable Use Policy', url: '/accept-usage-policy', description: 'Acceptable use guidelines for our services' },
        { name: 'Unlimited Hosting Policy', url: '/unlimited-hosting-policy', description: 'Terms and conditions for unlimited hosting plans' },
        { name: 'Service Level Agreement', url: '/sla', description: 'Our commitment to service quality and uptime guarantees' }
      ]
    }
  };

  const getIcon = (pageName) => {
    const iconMap = {
      'Home': <FaHome />,
      'Shared Hosting': <FaServer />,
      'cPanel Hosting': <FaCpanel />,
      'Reseller Hosting': <FaDesktop />,
      'VPS Hosting': <FaCloud />,
      'Cloud Hosting': <FaCloud />,
      'Domain Registration': <FaGlobe />,
      'IP Address Lookup': <FaSearch />,
      'DNS Records Checker': <FaDatabase />,
      'WHOIS Lookup': <FaSearch />,
      'Nameserver Checker': <FaNetworkWired />,
      'About Us': <FaInfoCircle />,
      'Contact Us': <FaPhone />,
      'Affiliate Program': <FaHandshake />,
      'Privacy Policy': <FaShieldAlt />,
      'Terms & Conditions': <FaFileAlt />,
      'Fair Usage Policy': <FaFileAlt />,
      'Refund Policy': <FaUndo />,
      'Acceptable Use Policy': <FaCheck />,
      'Unlimited Hosting Policy': <FaInfinity />,
      'Service Level Agreement': <FaFileContract />
    };
    return iconMap[pageName] || <FaFileAlt />;
  };

  const sitemapStyles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      paddingTop: '60px',
      paddingBottom: '60px'
    },
    header: {
      textAlign: 'center',
      marginBottom: '50px',
      padding: '0 20px'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: '#21a2a0',
      marginBottom: '15px',
      fontFamily: "'Poppins', sans-serif"
    },
    subtitle: {
      fontSize: '1.1rem',
      color: '#666',
      maxWidth: '600px',
      margin: '0 auto',
      lineHeight: '1.6'
    },
    section: {
      backgroundColor: '#ffffff',
      borderRadius: '15px',
      padding: '30px',
      marginBottom: '30px',
      boxShadow: '0 5px 15px rgba(0,0,0,0.08)',
      border: '1px solid #e9ecef'
    },
    sectionHeader: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '25px',
      paddingBottom: '15px',
      borderBottom: '2px solid #f8f9fa'
    },
    sectionIcon: {
      fontSize: '24px',
      marginRight: '15px',
      padding: '10px',
      borderRadius: '50%',
      backgroundColor: 'rgba(33, 162, 160, 0.1)'
    },
    sectionTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      margin: '0',
      color: '#2c3e50'
    },
    pageGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '20px'
    },
    pageCard: {
      display: 'flex',
      alignItems: 'flex-start',
      padding: '20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '10px',
      border: '1px solid #e9ecef',
      transition: 'all 0.3s ease',
      textDecoration: 'none',
      color: 'inherit'
    },
    pageCardHover: {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
      borderColor: '#21a2a0'
    },
    pageIcon: {
      fontSize: '20px',
      marginRight: '15px',
      marginTop: '2px',
      color: '#21a2a0'
    },
    pageContent: {
      flex: 1
    },
    pageName: {
      fontSize: '1.1rem',
      fontWeight: '600',
      color: '#21a2a0',
      marginBottom: '5px',
      textDecoration: 'none'
    },
    pageDescription: {
      fontSize: '0.9rem',
      color: '#666',
      lineHeight: '1.4',
      margin: '0'
    },
    stats: {
      backgroundColor: '#21a2a0',
      color: 'white',
      borderRadius: '15px',
      padding: '30px',
      textAlign: 'center',
      marginBottom: '40px'
    },
    statsTitle: {
      fontSize: '1.2rem',
      fontWeight: '600',
      marginBottom: '15px'
    },
    statsNumber: {
      fontSize: '2.5rem',
      fontWeight: '700',
      marginBottom: '5px'
    },
    statsText: {
      fontSize: '1rem',
      opacity: 0.9
    }
  };

  const totalPages = Object.values(sitemapData).reduce((total, section) => total + section.pages.length, 0);

  return (
    <>
      <Helmet>
        <title>Sitemap - ClubHosty | All Pages and Services</title>
        <meta
          name="description"
          content="Complete sitemap of ClubHosty website including all hosting services, domain registration, tools, company information and policies."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.clubhosty.com/sitemap" />
      </Helmet>

      <div style={sitemapStyles.container}>
        <div className="container">
          {/* Header */}
          <div style={sitemapStyles.header}>
            <h1 style={sitemapStyles.title}>Website Sitemap</h1>
            <p style={sitemapStyles.subtitle}>
              Complete overview of all pages and services available on ClubHosty. 
              Find exactly what you're looking for with our organized site structure.
            </p>
          </div>

          {/* Stats */}
          <div style={sitemapStyles.stats}>
            <div style={sitemapStyles.statsTitle}>Total Pages Available</div>
            <div style={sitemapStyles.statsNumber}>{totalPages}</div>
            <div style={sitemapStyles.statsText}>Organized across {Object.keys(sitemapData).length} main categories</div>
          </div>

          {/* Sitemap Sections */}
          {Object.entries(sitemapData).map(([sectionName, sectionData]) => (
            <div key={sectionName} style={sitemapStyles.section}>
              <div style={sitemapStyles.sectionHeader}>
                <div style={{...sitemapStyles.sectionIcon, color: sectionData.color}}>
                  {sectionData.icon}
                </div>
                <h2 style={sitemapStyles.sectionTitle}>{sectionName}</h2>
              </div>
              
              <div style={sitemapStyles.pageGrid}>
                {sectionData.pages.map((page, index) => (
                  <Link
                    key={index}
                    to={page.url}
                    style={sitemapStyles.pageCard}
                    onMouseEnter={(e) => {
                      Object.assign(e.target.style, sitemapStyles.pageCardHover);
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                      e.target.style.borderColor = '#e9ecef';
                    }}
                  >
                    <div style={sitemapStyles.pageIcon}>
                      {getIcon(page.name)}
                    </div>
                    <div style={sitemapStyles.pageContent}>
                      <div style={sitemapStyles.pageName}>{page.name}</div>
                      <p style={sitemapStyles.pageDescription}>{page.description}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}

          {/* Footer Note */}
          <div style={{
            textAlign: 'center',
            padding: '30px 20px',
            backgroundColor: '#ffffff',
            borderRadius: '15px',
            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
          }}>
            <h3 style={{color: '#21a2a0', marginBottom: '15px'}}>Need Help Finding Something?</h3>
            <p style={{color: '#666', marginBottom: '20px'}}>
              Can't find what you're looking for? Our support team is here to help 24/7.
            </p>
            <Link 
              to="/contact" 
              style={{
                backgroundColor: '#21a2a0',
                color: 'white',
                padding: '12px 30px',
                borderRadius: '25px',
                textDecoration: 'none',
                fontWeight: '600',
                display: 'inline-block',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#1e8e8b';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#21a2a0';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              Contact Support
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sitemap;
